module.exports = __webpack_public_path__ + "static/media/marker-on-icon.8b9d2b43.svg";